import { render } from "./AddEmployeeDialog.vue?vue&type=template&id=4352acc3&scoped=true&ts=true"
import script from "./AddEmployeeDialog.vue?vue&type=script&lang=ts"
export * from "./AddEmployeeDialog.vue?vue&type=script&lang=ts"

import "./AddEmployeeDialog.vue?vue&type=style&index=0&id=4352acc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4352acc3"]])

export default __exports__